import { PlanNames } from '@inspiral/subscription-contracts';

export enum LicenseeStatus {
  LEGAL = 'LEGAL',
  INDIVIDUAL_ENTREPRENEUR = 'INDIVIDUAL_ENTREPRENEUR',
}

export const choices = [
  { id: LicenseeStatus.LEGAL, name: 'Юридическое лицо' },
  {
    id: LicenseeStatus.INDIVIDUAL_ENTREPRENEUR,
    name: 'Индивидуальный предприниматель',
  },
];

export const planNameChoices = [
  { id: PlanNames.free, name: 'Базовый' },
  { id: PlanNames.pro1, name: 'Профи 1' },
  { id: PlanNames.pro5, name: 'Профи 5' },
  { id: PlanNames.pro10, name: 'Профи 10' },
  { id: PlanNames.guru, name: 'Гуру' },
];
